var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.736 58.264c-8.353-8.352-21.942-8.352-30.295 0l-9.177 9.177c-8.352 8.353-8.352 21.942 0 30.295 8.353 8.352 21.942 8.352 30.295 0l9.177-9.177c8.352-8.353 8.352-21.942 0-30.295zM27.903 89.08a9.168 9.168 0 0 1-12.983 0 9.168 9.168 0 0 1 0-12.983l9.177-9.177a9.17 9.17 0 0 1 12.983 0 9.168 9.168 0 0 1 0 12.983l-9.177 9.177z",
    fill: "#4A99F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.732 88.55-9.181 9.182c-8.357 8.357-21.954 8.357-30.311 0l8.66-8.66a9.173 9.173 0 0 0 12.99 0l9.182-9.181a9.174 9.174 0 0 0 0-12.99l8.66-8.661c8.357 8.357 8.357 21.954 0 30.31z",
    fill: "#4A99F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.441 6.264-9.177 9.177c-8.352 8.353-8.352 21.942 0 30.295 8.353 8.352 21.942 8.352 30.295 0l9.177-9.177c8.352-8.353 8.352-21.942 0-30.295-8.353-8.352-21.942-8.352-30.295 0zM79.903 37.08a9.17 9.17 0 0 1-12.983 0 9.168 9.168 0 0 1 0-12.983l9.177-9.177a9.168 9.168 0 0 1 12.983 0 9.168 9.168 0 0 1 0 12.983l-9.177 9.177z",
    fill: "#6173FE"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFD044"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.2 62.064-1.932 5.795-12.957-4.32 1.931-5.794zM63.532 68.31l4.319 12.958-5.796 1.932-4.318-12.958zM41.938 20.8l4.319 12.958-5.796 1.932-4.318-12.958zM35.689 40.466l-1.931 5.796-12.958-4.32 1.931-5.795z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m97.732 36.55-9.181 9.182c-8.357 8.357-21.954 8.357-30.311 0l8.66-8.66a9.174 9.174 0 0 0 12.99 0l9.182-9.181a9.173 9.173 0 0 0 0-12.99l8.66-8.661c8.357 8.357 8.357 21.954 0 30.31z",
    fill: "#6173FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.488 27.512a9.124 9.124 0 0 0-12.922 0L48.49 42.588 61.412 55.51l15.076-15.076a9.124 9.124 0 0 0 0-12.922zM42.587 48.49 27.511 63.566a9.126 9.126 0 0 0 0 12.923 9.125 9.125 0 0 0 12.923 0L55.51 61.413 42.587 48.49z",
    fill: "#FFD044"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.a5499c4b.svg";
export { ForwardRef as ReactComponent };